import PropTypes from 'prop-types';
import { Image } from '../index';

const MediaBlock = ({ media, fit = 'cover' }) => {
  if (!media?.type) return null;

  const { type, url, title, caption } = media;

  const renderMedia = () => {
    if (type === 'image') {
      return <Image image={media} fit={fit} />;
    }

    if (url) {
      return (
        <img
          src={url}
          alt={title || ''}
          className="w-full h-auto"
        />
      );
    }

    return null;
  };

  const rendered = renderMedia();
  if (!rendered) return null;

  return (
    <div className="media-block">
      {rendered}
      {caption && (
        <div className="text-body-sm text-neutral-600 mt-sm">{caption}</div>
      )}
    </div>
  );
};

MediaBlock.propTypes = {
  media: PropTypes.shape({
    type: PropTypes.string.isRequired,
    url: PropTypes.string,
    title: PropTypes.string,
    caption: PropTypes.string,
  }),
  fit: PropTypes.oneOf(['responsive', 'contain', 'cover', 'fill']),
};

MediaBlock.defaultProps = {
  media: null,
  fit: 'cover',
};

export default MediaBlock;